import { render } from "./EditCriminalModal.vue?vue&type=template&id=0fd1728b"
import script from "./EditCriminalModal.vue?vue&type=script&lang=js"
export * from "./EditCriminalModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__